import { graphql } from 'react-relay';

export const updateDrawingSetAnnotationMutation = graphql`
    mutation updateDrawingSetAnnotationMutation($id: ID!, $input: DrawingSetAnnotationUpdateInput!) {
        updateDrawingSetAnnotation(id: $id, input: $input) {
            ...drawingSetAnnotationFragment
        }
    }
`;
